// Super simple sync / async validation based on chriso/validator.js
import ValidationError from "./ValidationError";
import validator from "validator";

// Subclass to add custom validations.
class Validation {
  // JSON to be validated.
  constructor(object) {
    this.object = object;
    this.currentProp = null;
    this.currentValue = null;

    this.isError = false;
    this.errors = {};
  }

  getErrors() {
    if (this.isError) {
      return new ValidationError(this.errors);
    }
  }

  addToErrors(error, prop) {
    if (this.errors[prop] === undefined) {
      this.errors[prop] = [];
    }
    let err = this.errors[prop];
    if (err.length === 1 && err[0].type == "required") {
      return;
    }
    this.isError = true;
    this.errors[prop].push(error);
  }

  isEmptyString(value) {
    if (value === undefined || value === null || isNaN(value)) {
      return false;
    }
    return !validator.toString(value).trim();
  }

  prop(prop, multiProp) {
    this.currentProp = prop;
    this.currentValue = this.object[prop];

    this.multiProp = multiProp;

    return this;
  }

  required(errorMessage) {
    if (this.isEmptyString(this.currentValue)) {
      this.addToErrors(
        {
          type: "required",
          message: errorMessage
        },
        this.multiProp || this.currentProp
      );
    }
    return this;
  }

  email(errorMessage) {
    if (!validator.isEmail(this.currentValue)) {
      this.addToErrors(
        {
          type: "email",
          message: errorMessage
        },
        this.multiProp || this.currentProp
      );
    }
    return this;
  }
}

export default Validation;



// WEBPACK FOOTER //
// ./src/common/lib/validation/Validation.js